import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { PageInfoService, PageLink } from '@metronic/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '@services/base-service.service';
import { UtilitiesService } from '@services/utilities.service';
import { TabListLabelPending } from '../../enum/tablist-label.enum';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { BehaviorSubject, Subscription } from 'rxjs';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { RegistrationComponent } from './registration/registration.component';
import { VerificationComponent } from './verification/verification.component';
import { EditRequestComponent } from './edit-request/edit-request.component';
import { ITabList } from '@shared/interface/tablist.interface';
import { DistributorTabStatus } from '@config/enum/distributor.enum';
import { DetailRegistrationDistributorService } from '../../distributor-detail/detail-pending/detail-registration/detail-registration.service';
import { API } from '@config/constants/api.constant';
import { NonActiveComponent } from './non-active/non-active.component';

@Component({
  selector: 'app-pending',
  templateUrl: './pending.component.html',
  styleUrls: ['./pending.component.scss'],
})
export class PendingComponent implements OnInit, AfterViewInit, OnDestroy {
  countRegister = new BehaviorSubject<number>(0);
  countVerification = new BehaviorSubject<number>(0);
  countEditRequest = new BehaviorSubject<number>(0);
  countNonActive = new BehaviorSubject<number>(0);

  tabIndex: number = 0;
  tab: any | null = null;

  TabListLabel = TabListLabelPending;
  tabList: ITabList[];

  links: Array<PageLink> = [
    {
      title: 'Distributor',
      path: '',
      isActive: false,
    },
    {
      title: '',
      path: '',
      isActive: false,
      isSeparator: true,
    },
    {
      title: 'Sedang Menunggu',
      path: '',
      isActive: true,
    },
  ];

  private unsubscribe: Subscription[] = [];

  constructor(
    private pageInfoService: PageInfoService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private baseService: BaseService,
    public utilities: UtilitiesService,
    private rolePrivilegeService: RolePrivilegeService,
    private registrationService: DetailRegistrationDistributorService
  ) {
    this.registrationService.clearAllSessionRevisionNote();
  }

  ngOnInit(): void {
    this.initTabList();
    this.initPageInfo();
    this.handlePrivilege();
    this.handleCurrentActiveTab();
  }

  ngAfterViewInit() {
    this.initGetListDataCount();
  }

  initTabList() {
    this.tabList = [
      {
        tab: 'registration',
        enum: 'TAB_LIST_REGISTRATION_REQUEST',
        labelKey: 'registration_request',
        privilege: null,
        dataCount: this.countRegister,
        component: RegistrationComponent,
      },
      {
        tab: 'verification',
        enum: 'TAB_LIST_VERIFICATION_REQUEST',
        labelKey: 'verification_request',
        privilege: null,
        dataCount: this.countVerification,
        component: VerificationComponent,
      },
      {
        tab: 'edit-request',
        enum: 'TAB_LIST_SA_EDIT_REQUEST',
        labelKey: 'edit_request',
        privilege: null,
        dataCount: this.countEditRequest,
        component: EditRequestComponent,
      },
      {
        tab: 'non-active',
        enum: 'TAB_LIST_PENDING_NONACTIVATED',
        labelKey: 'non_active',
        privilege: null,
        dataCount: this.countNonActive,
        component: NonActiveComponent,
      },
    ];
  }

  handleCurrentActiveTab() {
    this.tab = this.activatedRoute.snapshot.params.tab;
    const _currentActiveTab = this.tabList.filter((item) => item.tab === this.tab);
    this.tabIndex = this.tabList.indexOf(_currentActiveTab[0]);
  }

  handlePrivilege() {
    this.tabList.map((tab) => (tab.privilege = this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_MENUNGGU', tab.enum)));

    this.tabList = this.tabList
      .filter((tab) => tab.privilege === true)
      .map((tab, index) => {
        tab.index = index;
        return tab;
      });

    this.changeFirstTab();
  }

  changeFirstTab() {
    const _data: { tab: string; privilege: boolean }[] = [];
    this.tabList.forEach((item) => {
      _data.push({ tab: item.tab, privilege: !!item.privilege });
    });

    if (!this.tabList[0].privilege) {
      const _changeTab = this.rolePrivilegeService.changePrivilegeUrlTab(_data, 'distributor', DistributorTabStatus.PENDING);
      this.router.navigate([_changeTab]).then(() => this.initPageInfo());
    }
  }

  tabClick(e: MatTabChangeEvent) {
    this.tabIndex = e.index;
    const { tab } = this.tabList[e.index];
    this.router.navigate([`/distributor/pending/${tab}`]).then(() => this.initPageInfo());
  }

  initPageInfo() {
    this.pageInfoService.updateTitle(`Distributor Pending`);
    this.pageInfoService.updateBreadcrumbs(this.links);
  }

  initGetListDataCount() {
    const _dataCounterSubs = this.baseService.getData<any>(API.DISTRIBUTOR.LIST_COUNTER.PENDING).subscribe((resp) => {
      if (!resp) return;
      const { distributor_pending_edit_verification, distributor_pending_registration, distributor_pending_verification, distributor_pending_deactivation } = resp && resp.data;
      this.countEditRequest.next(distributor_pending_edit_verification);
      this.countRegister.next(distributor_pending_registration);
      this.countVerification.next(distributor_pending_verification);
      this.countNonActive.next(distributor_pending_deactivation ?? 0);
    });

    this.unsubscribe.push(_dataCounterSubs);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
